// import React from 'react';
// import { Button, Stack, Grid } from '@mui/material';
// import { ReactComponent as Checkin } from 'assets/images/SVG/Check-in Dark.svg';
// import { ReactComponent as GenerateOTP } from 'assets/images/SVG/Generate OTP Dark.svg';
// import { useNavigate } from 'react-router-dom';
// import PermissionGuard from 'utils/route-guard_vms/PermissionGuard';
// material-ui
import { Button, Stack, Grid, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// router
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'store';
import { isReceptionist, RECEPTIONIST_ACCENT, RECEPTIONIST_SIDEBAR_BG, RECEPTIONIST_SURFACE } from '../MiniDrawerStyled';
import { getCheckInDestination, hasBothCheckInFlows, hasCheckInAccess } from 'utils/checkinRoute';
import { Profile2User, UserTick } from 'iconsax-react';

// ==============================|| DRAWER CONTENT - NAV CARD (COLLAPSED) ||============================== //
// Icon-only counterpart to NavCard.js, shown instead of it when the rail is collapsed (see
// Drawer/index.js: `drawerOpen ? <NavCard /> : <NavCardIcon />`). Same canCheckIn OR-logic as
// NavCard.js — a plain PermissionGuard here hid the button entirely for Receptionist, since the
// backend hasn't configured a customer/check-in permission for that role yet.
const NavCardIcon = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const receptionist = isReceptionist();
  const permissions = useSelector((state) => state.auth?.permissions || []);
  const canCheckIn = hasCheckInAccess(permissions, receptionist);

  // Same rationale as NavCard.js: show two buttons only when both check-in flows are actually available.
  const showBothCheckIns = hasBothCheckInFlows(permissions, receptionist);
  const circleButtonBaseSx = {
    minWidth: 0,
    width: 40,
    height: 40,
    borderRadius: '50%',
    p: 0,
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
      transform: 'translateY(-2px)'
    }
  };

  const frontCircleButtonSx = {
    ...circleButtonBaseSx,
    color: RECEPTIONIST_SIDEBAR_BG,
    backgroundColor: RECEPTIONIST_SURFACE,
    '&:hover': {
      ...circleButtonBaseSx['&:hover'],
      backgroundColor: RECEPTIONIST_ACCENT,
      color: RECEPTIONIST_SIDEBAR_BG
    }
  };

  const vmsCircleButtonSx = {
    ...circleButtonBaseSx,
    color: theme.palette.primary.darker,
    backgroundColor: theme.palette.primary.lighter,
    '&:hover': {
      ...circleButtonBaseSx['&:hover'],
      backgroundColor: theme.palette.primary.main,
      color: '#ffffff'
    }
  };

  return (
    <Grid container spacing={2} sx={{ p: 3, maxWidth: '100vw', overflow: 'hidden' }}>
      <Grid item xs={12}>
        <Stack alignItems="center" spacing={2}>
          {showBothCheckIns ? (
            <>
              <Tooltip title="Check-in - Front" placement="right">
                <Button
                  sx={frontCircleButtonSx}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/vms/checkin/frontdesk');
                  }}
                >
                  <UserTick size="20" />
                </Button>
              </Tooltip>
              <Tooltip title="Check-in - VMS" placement="right">
                <Button
                  sx={vmsCircleButtonSx}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/vms/checkin');
                  }}
                >
                  <Profile2User size="20" />
                </Button>
              </Tooltip>
            </>
          ) : (
            canCheckIn && (
              <Button
                sx={frontCircleButtonSx}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(getCheckInDestination(permissions, receptionist), { state: { detail: true } });
                }}
              >
                <UserTick size="20" />
              </Button>
            )
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default NavCardIcon;
